<template>
  <div>
    <b-card>
      <ValidationObserver ref="faq" v-slot="{ handleSubmit }">
        <b-form class="form-top p-4" @submit.prevent="handleSubmit(formSubmit)">
          <b-row>
            <b-col md="6">
              <textarea-form
                v-model="faq.faq.translations[0].question"
                :name="$t('faqs.questionAr')"
                :label="$t('faqs.questionAr')"
                validate="required"
                :disabled="disableStatus"
              />
            </b-col>
            <b-col md="6">
              <textarea-form
                v-model="faq.faq.translations[1].question"
                :name="$t('faqs.questionEn')"
                :label="$t('faqs.questionEn')"
                validate="required"
                :disabled="disableStatus"
              />
            </b-col>

            <b-col md="6">
              <textarea-form
                v-model="faq.faq.translations[0].answer"
                :name="$t('faqs.answerAr')"
                :label="$t('faqs.answerAr')"
                validate="required"
                :disabled="disableStatus"
              />
            </b-col>
            <b-col md="6">
              <textarea-form
                v-model="faq.faq.translations[1].answer"
                :name="$t('faqs.answerEn')"
                :label="$t('faqs.answerEn')"
                validate="required"
                :disabled="disableStatus"
              />
            </b-col>
          </b-row>

          <form-btns
            v-if="currentPage != itemPages.view"
            :label="submitLabel"
            :loading="loading"
          />
        </b-form>
      </ValidationObserver>
    </b-card>
  </div>
</template>
<script>
import { core } from "../../../../config/pluginInit";
import faqServices from "../services/faqs";
import FAQ from "../models/FAQ";
import moduleItemMixin from "../../../../Mixins/moduleItemMixin";

export default {
  mixins: [moduleItemMixin],
  data() {
    return {
      faq: new FAQ(),
    };
  },
  methods: {
    async create() {
      faqServices
        .create({ translations: this.faq.faq.translations })
        .then((response) => {
          this.loading = false;
          core.showSnackbar("success", response.data.message);
          this.lastRoute.name
            ? this.$router.push(this.lastRoute)
            : this.$router.push({ name: "generalSettings.faqs" });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async update() {
      faqServices
        .update(this.id, { translations: this.faq.faq.translations })
        .then((response) => {
          this.loading = false;
          core.showSnackbar("success", response.data.message);
          this.lastRoute.name
            ? this.$router.push(this.lastRoute)
            : this.$router.push({ name: "generalSettings.faqs" });
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    core.index();
  },
  created() {
    if (this.id) {
      faqServices.findOne(this.id).then((response) => {
        this.faq.fillData(response.data.data);
        this.loading = false;
      });
    } else {
      this.loading = false;
    }
  },
};
</script>
